module.exports = __webpack_public_path__ + "img/badge.dcefa7e3.png";